import React, { Component } from 'react';
import { Route, Routes } from 'react-router-dom';

import theme from './theme/muiTheme';
import {ThemeProvider} from '@mui/material';

import HomePage from './pages/Home';
import Login from './pages/Login';
import ControlPage from './pages/Control/Control';
import LeaderBoardPage from './pages/Leaderboard';

class App extends Component{

    constructor() {
        super();
        
        if(localStorage.getItem('token')!=null){
            this.state = {
                userAuth: true
            };
        }else{
            this.state = {
                userAuth: false
            };
        }
    
        this.handleLogin = this.handleLogin.bind(this);
        this.handleLogout = this.handleLogout.bind(this);
      }


    handleLogout() {
        this.setState({
            userAuth: false
        });

        localStorage.removeItem('token');
        localStorage.removeItem('userRole');
        localStorage.removeItem('userProfile');
        localStorage.removeItem('clubProfile');

    }

    handleLogin(data) {
        this.setState({
            userAuth: true
        });

    }


    

    render(){
        return (
            <ThemeProvider theme={theme}>
                <Routes>
                    <Route index element={<LeaderBoardPage/>}/>    
                    <Route exact path="/control" element={<ControlPage userAuthStatus={this.state.userAuth}/>}/>
                    <Route exact path="/leaderboard" element={<LeaderBoardPage/>}/>     
                    <Route exact path="/login" element={<Login handleLogin={this.handleLogin} handleLogout={this.handleLogout} userAuthStatus={this.state.userAuth}/>} />
                </Routes>
            </ThemeProvider>
        );
    }
}

export default App;
